export default __webpack_public_path__ + "static/media/reunion22_w320.bae1a98f.jpg";